import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Tooltip from '@/ui/components/Tooltip';
import { truncateErrorMessage } from '@/utils/truncateErrorMessage';

const MessageErrorIndicator = ({ errorMessage }: { errorMessage: string }) => {
  const detail = `Undelivered: ${truncateErrorMessage(errorMessage)}`;

  return (
    <span className="absolute -right-1.5 -top-1.5">
      <Tooltip tooltipContent={detail} className="break-words" interactive>
        <span
          role="img"
          aria-label={detail}
          className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-uniform-red-600 ring-2 ring-white dark:bg-uniform-red-500 dark:ring-uniform-gray-900">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            aria-hidden="true"
            className="text-[10px] text-white"
          />
        </span>
      </Tooltip>
    </span>
  );
};

export default MessageErrorIndicator;
